import { createUseStyles } from 'react-jss';
import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  eventImage: {
    ...mixins.getStaticIconSize(306),

    '& .viboImage': {
      width: '100%',
      height: '100%',
    },

    '& .eventTypeIcon': {
      fontSize: '100px!important',

      '@media screen and (min-width: 1441px)': {
        fontSize: '120px!important',
      },
    },

    '@media screen and (min-width: 1441px)': {
      ...mixins.getStaticIconSize(452),
    },
  },

  noImageText: {
    color: 'var(--background-paper)',
    position: 'absolute',
    bottom: '22%',
    fontSize: '18px',
    fontWeight: 500,

    '@media screen and (min-width: 1441px)': {
      fontSize: '24px',
    },
  },
}));

export default useStyles;
